// external libs
import React from 'react'
import { FormRenderProps } from 'react-final-form'
import _ from 'lodash'
import { useHistory } from 'react-router-dom'

// hooks & stores
import checkPermission from '../../../../../../utilities/checkPermission'
import useAppFolderAndTabAction from '../../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import useLoading from '../../../../../../control/loading/useLoading'
import useTranslate from '../../../../../../i18n/useTranslate'
import useWebService from '../../../../../../services/web/useWebService'
import useFolderAndTab from '../../../useFolderAndTab'
import useLookupService from '../../../../../../services/lookup/useLookupService'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useAppAlertMessageAction from '../../../../../../stores/appAlertMessage/appAlertMessageAction'

// constants & utilities
import * as memoMessageType from './memoMessageType'
import { DataSourceType } from '../../../../../../control/treeCheckboxNew/treeCheckbox'
import { dateForAPI } from '../../../../../../utilities/date'
import { InitialRichTextEditorType } from '../../../../../../control/richTextEditor/richTextEditor'
import { memorandumTopic } from '../../../../../../constants/constants'
import constSubmittedType from '../../../../../../constants/submittedType'
import { UploadFileObjCerType } from '../../generateCertificate/generateCertificateType'
import constConsiderType from '../../../../../../constants/considerType'
import * as Constant from '../../../../../../constants/constants'
import { validateModeAccordionError } from '../../../../../../utilities/validate'

// types
import * as REQServiceType from '../../../../../../services/web/types/requestWebServiceTypes'
import { DialogType } from '../../../../../../control/dialog/dialog'
import { RoutePath } from '../../../../../../router/routesConfig'

const useMemomessageTerminate = (props: memoMessageType.UseMemoMessageType) => {
    const { onSaveComplete } = props
    const appAlertMessageAction = useAppAlertMessageAction()
    const callWebService = useWebService()
    const checkPermissionHook = checkPermission()
    const tabAndFolderHook = useFolderAndTab()
    const history = useHistory()
    const translate = useTranslate()
    const loadingHook = useLoading()
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const manageProjectStore = useManageProjectStore()
    const projectData = manageProjectStore.projectData

    const [initialValues, setInitialValues] = React.useState<any>({})
    const [required, setRequired] = React.useState<boolean>(true)

    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const isShowUpdateDate = checkPermissionHook.chkShowUpdateDate(projectData)

    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogRef = React.useRef<Record<string, Function>>()
    const formRef = React.useRef<FormRenderProps>()
    const editRef = React.useRef<any>()
    const callLookup = useLookupService()
    const [terminateCauseList, setTerminateCause] = React.useState<{ id: number; name_th: string; name_en: string }[]>(
        [],
    )
    const [isCheckedOther, setIsCheckedOther] = React.useState<boolean>(false)
    const [initialSuggestionNotice, setInitialSuggestionNotice] = React.useState<InitialRichTextEditorType>()
    const [initialMemoMessagePaper, setInitialMemoMessagePaper] = React.useState<{
        TH: InitialRichTextEditorType
        EN: InitialRichTextEditorType
    }>()
    const [initialMemorandumFile, setInitialMemorandumFile] = React.useState<any>()
    const [approveStatus, setApproveStatus] = React.useState<memoMessageType.OptType[]>([])

    const [approveStatusServiceResult, setApproveStatusServiceResult] = React.useState<Array<any>>([])

    React.useEffect(() => {
        if (projectData) {
            createInitialData()
        }

        if (projectData?.considerInfo && projectData?.considerInfo?.value) {
            setRequired(projectData?.considerInfo?.value === constConsiderType.exempt ? false : true)
        }
    }, [projectData?.projectID ?? null, projectData?.submittedID ?? null, projectData?.considerInfo ?? null])

    React.useEffect(() => {
        getLutTerminateProjectCause()
        getApproveStatus()
    }, [translate.languageStore.currentLanguage])

    const getApproveStatus = async () => {
        let res
        if (projectData?.irb) {
            res = await callLookup.callApproveStatusLut(
                projectData?.irb,
                constSubmittedType.highRiskProjectProgressReport,
            )

            if (res) {
                setApproveStatusServiceResult(res?.result ?? [])
                const formatedData = res?.result?.map((itm) => {
                    return {
                        label:
                            translate.languageStore.currentLanguage === translate.languageKey.th
                                ? itm.name_th
                                : itm.name_en,
                        value: `${itm.id}`,
                    }
                }) as []
                setApproveStatus(formatedData)
            }
        }
    }

    const getLutTerminateProjectCause = async () => {
        const res = await callLookup.getTerminateCause(1, 8)

        setTerminateCause(res.result)
    }
    const onRefDialog = (func: Record<string, Function>) => {
        dialogRef.current = func
    }

    const createInitialData = async () => {
        const submittedID = manageProjectStore?.projectData?.submittedID ?? null

        if (submittedID) {
            const res = await callWebService.getProjectProgressReportMemoMessage(submittedID)
            const result = res.result

            const initialData = {
                memoMessageDate: result.memoMessageCommentDate ? new Date(result.memoMessageCommentDate) : new Date(),
                approveStatus:
                    result && result?.approveStatusInfo
                        ? {
                              label:
                                  translate.languageStore.currentLanguage === translate.languageKey.th
                                      ? result?.approveStatusInfo.nameTH
                                      : result?.approveStatusInfo.nameEN,
                              value: result?.approveStatusInfo.value.toString(),
                          }
                        : null,
            }

            const initialSugestionNotice = {
                contentHtml: result?.memoMessageComment_html ?? '',
                contentText: result?.memoMessageComment ?? '',
            }
            const initialMemoMessagePaper = {
                TH: {
                    contentHtml: result?.memoMessagePaper_th_html ?? '',
                    contentText: result?.memoMessagePaper_th ?? '',
                },
                EN: {
                    contentHtml: result?.memoMessagePaper_en_html ?? '',
                    contentText: result?.memoMessagePaper_en ?? '',
                },
            }
            const initialMemorandumFile = createInitialFileMemorandum(result.memoMessagePaperInfo)

            setInitialSuggestionNotice(initialSugestionNotice)
            setInitialMemoMessagePaper(initialMemoMessagePaper)
            setInitialMemorandumFile(initialMemorandumFile)
            setInitialValues(initialData)
        }
    }

    const createInitialFileMemorandum = (memorandumInfo: any) => {
        const uploadFileMemoranduminit: Array<UploadFileObjCerType> = memorandumTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                },
            }
        })
        uploadFileMemoranduminit.forEach((itm: UploadFileObjCerType) => {
            if (itm.uploadFileObj.documentTopicID === 0) {
                if (memorandumInfo?.name_th) {
                    let fileListTH = {
                        documentTopicID: 0,
                        fileToken: memorandumInfo?.name_th,
                        filename: memorandumInfo?.name_th,
                        fileID: memorandumInfo?.name_th,
                        path: memorandumInfo?.unSignPathInfo?.path_th,
                    }
                    //@ts-ignore
                    itm.uploadFileObj.fileList.push(fileListTH)
                }
            } else if (itm.uploadFileObj.documentTopicID === 1) {
                if (memorandumInfo?.name_en) {
                    let fileListEN = {
                        documentTopicID: 1,
                        fileToken: memorandumInfo?.name_en,
                        filename: memorandumInfo?.name_en,
                        fileID: memorandumInfo?.name_en,
                        path: memorandumInfo?.unSignPathInfo?.path_en,
                    }
                    //@ts-ignore
                    itm.uploadFileObj.fileList.push(fileListEN)
                }
            }

            itm.uploadFileObj.subTopicPageList = []
        })
        return uploadFileMemoranduminit
    }

    const getSaveServiceParameter = (isDraft: boolean) => {
        const value = formRef.current?.values

        const submittedID = manageProjectStore?.projectData?.submittedID ?? null

        let param: REQServiceType.ProjectAdverseEventMemomessageType = {
            submittedID: submittedID,
            comment: value?.suggestionNotice?.contentText,
            comment_html: value?.suggestionNotice?.contentHtml,
            memoMessagePaper_th: value?.memoMessagePaper_TH?.contentText,
            memoMessagePaper_en: value?.memoMessagePaper_EN?.contentText,
            memoMessagePaper_th_html: value?.memoMessagePaper_TH?.contentHtml,
            memoMessagePaper_en_html: value?.memoMessagePaper_EN?.contentHtml,
            memoMessageDate: value?.memoMessageDate ? dateForAPI(value?.memoMessageDate) ?? null : null,
            approveStatusID: value?.approveStatus ? parseInt(value?.approveStatus.value) : null,
            isDraft: isDraft,
        }

        return param
    }

    const handleChangProjectType = (val: memoMessageType.OptType) => {
        if (parseInt(val?.value) === 3) {
            setRequired(false)
        } else {
            setRequired(true)
        }
    }

    const handleDirtyChange = (props: any) => {
        let isDirty: boolean = false
        let newFormValue = _.omit(props.values, ['memorandumFile'])
        let initValue = _.omit(
            {
                ...initialValues,
                memoMessagePaper_EN: initialMemoMessagePaper?.EN,
                memoMessagePaper_TH: initialMemoMessagePaper?.TH,
                suggestionNotice: initialSuggestionNotice,
            },
            ['submitType'],
        )

        const isEqual = _.isEqual(initValue, newFormValue)

        if (!isViewMode) {
            if (isEqual) {
                isDirty = false
            } else {
                isDirty = true
            }
        }

        const paramsDirty = {
            tabDirty: isDirty,
            callbackDirty: isDirty ? callbackDirtyProcess : undefined,
        }

        appFolderAndTabAction.setDirty(paramsDirty)
    }

    const callbackDirtyProcess = (tabIndex: number, newTabSelected: any) => {
        const isDraft = true
        const param: REQServiceType.ProjectAdverseEventMemomessageType = getSaveServiceParameter(isDraft)
        processSaveData(param, {
            idx: tabIndex,
            selectedInfo: newTabSelected,
        })
    }

    const handleClickBackToSearch = () => {
        history.push(RoutePath.manageProject)
    }

    const handleSubmitForm = (value: any) => {
        const isDraft: boolean = value?.submitType !== 'save'
        const param: REQServiceType.ProjectAdverseEventMemomessageType = getSaveServiceParameter(isDraft)
        if (isDraft) {
            processSaveData(param)
        } else {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
                type: 'alert-confirm',
                onClickConfirm: () => {
                    processSaveData(param)
                },
            })

            dialogRef.current?.openDialog()
        }
    }

    const processSaveData = async (
        param: REQServiceType.ProjectAdverseEventMemomessageType,
        changeTabOpt?: { idx: number; selectedInfo: any },
    ) => {
        dialogRef.current?.closeDialog()
        try {
            loadingHook.loadingOpen()
            const response = await callWebService.projectProgressReportMemoMessage(param)
            if (changeTabOpt) {
                if (changeTabOpt.idx !== null && changeTabOpt.selectedInfo !== null) {
                    tabAndFolderHook.setTab(changeTabOpt.idx, changeTabOpt.selectedInfo)
                }
            } else {
                if (onSaveComplete) onSaveComplete(response.status, param.isDraft as boolean)
            }
        } catch (ex) {
            console.log('useMemomessageTerminate.ts => processSaveData : ', ex)
        } finally {
            loadingHook.loadingClose()
        }
    }

    const handleClickCheckbox = (selectedItem: DataSourceType) => {
        if (selectedItem.id === 4) {
            setIsCheckedOther(!isCheckedOther)
        }
    }

    const handleClickOpenFile = async (url: string) => {
        let xmlHttp = new XMLHttpRequest()
        xmlHttp.open('GET', url, true) // false for synchronous request
        xmlHttp.onreadystatechange = function () {
            // In local files, status is 0 upon success in Mozilla Firefox
            if (xmlHttp.readyState === XMLHttpRequest.DONE) {
                var status = xmlHttp.status
                if (status === 0 || (status >= 200 && status < 400)) {
                    // The request has been completed successfully
                    window.open(url)
                } else {
                    // Oh no! There has been an error with the request!
                    appAlertMessageAction.openAlertMessage({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        message: translate.get('MESSAGE.M011'),
                    })
                }
            }
        }
        xmlHttp.send()
    }
    const handleChangeStatus = (val: any) => {
        const selectItem = approveStatusServiceResult?.filter(
            (status) => status.id.toString() === val?.value?.toString(),
        )?.[0]

        if (selectItem && selectItem?.id) {
            let fieldMemoMessagePaperTH = {
                contentHtml: formRef.current?.values?.memoMessagePaper_TH?.contentHtml ?? null,
                contentText: formRef.current?.values?.memoMessagePaper_TH?.contentText ?? null,
            }
            let fieldMemoMessagePaperEN = {
                contentHtml: formRef.current?.values?.memoMessagePaper_EN?.contentHtml ?? null,
                contentText: formRef.current?.values?.memoMessagePaper_EN?.value ?? null,
            }

            if (fieldMemoMessagePaperTH.contentHtml && fieldMemoMessagePaperTH.contentHtml?.trim() !== '') {
                fieldMemoMessagePaperTH.contentHtml = fieldMemoMessagePaperTH.contentHtml.replaceAll(
                    Constant.pleaseSelectApproveStatus.th,
                    selectItem.name_th,
                )

                if (fieldMemoMessagePaperTH.contentText && fieldMemoMessagePaperTH.contentText?.trim() !== '') {
                    fieldMemoMessagePaperTH.contentText = fieldMemoMessagePaperTH.contentText.replaceAll(
                        Constant.pleaseSelectApproveStatus.th,
                        selectItem.name_th,
                    )
                }
            }

            if (fieldMemoMessagePaperEN.contentHtml && fieldMemoMessagePaperEN.contentHtml?.trim() !== '') {
                fieldMemoMessagePaperEN.contentHtml = fieldMemoMessagePaperEN.contentHtml.replaceAll(
                    Constant.pleaseSelectApproveStatus.en,
                    selectItem.name_en,
                )

                if (fieldMemoMessagePaperEN.contentText && fieldMemoMessagePaperEN.contentText?.trim() !== '') {
                    fieldMemoMessagePaperEN.contentText = fieldMemoMessagePaperEN.contentText.replaceAll(
                        Constant.pleaseSelectApproveStatus.en,
                        selectItem.name_en,
                    )
                }
            }
            approveStatusServiceResult.forEach((status) => {
                if (fieldMemoMessagePaperTH.contentHtml && fieldMemoMessagePaperTH.contentHtml?.trim() !== '') {
                    fieldMemoMessagePaperTH.contentHtml = fieldMemoMessagePaperTH.contentHtml.replaceAll(
                        status.name_th,
                        selectItem.name_th,
                    )

                    if (fieldMemoMessagePaperTH.contentText && fieldMemoMessagePaperTH.contentText?.trim() !== '') {
                        fieldMemoMessagePaperTH.contentText = fieldMemoMessagePaperTH.contentText.replaceAll(
                            status.name_th,
                            selectItem.name_th,
                        )
                    }
                }

                if (fieldMemoMessagePaperEN.contentHtml && fieldMemoMessagePaperEN.contentHtml?.trim() !== '') {
                    fieldMemoMessagePaperEN.contentHtml = fieldMemoMessagePaperEN.contentHtml.replaceAll(
                        status.name_en,
                        selectItem.name_en,
                    )

                    if (fieldMemoMessagePaperEN.contentText && fieldMemoMessagePaperEN.contentText?.trim() !== '') {
                        fieldMemoMessagePaperEN.contentText = fieldMemoMessagePaperEN.contentText.replaceAll(
                            status.name_en,
                            selectItem.name_en,
                        )
                    }
                }
            })

            setInitialMemoMessagePaper({
                TH: {
                    contentHtml: fieldMemoMessagePaperTH.contentHtml,
                    contentText: fieldMemoMessagePaperTH.contentText,
                },
                EN: {
                    contentHtml: fieldMemoMessagePaperEN.contentHtml,
                    contentText: fieldMemoMessagePaperEN.contentText,
                },
            })
        }
    }

    const updateMemoMessage = async (param: REQServiceType.UpdateMemoMessageType) => {
        loadingHook.loadingOpen()
        const res = await callWebService.updateMemoMessagePaper(param)

        if (res.result.status === 200) {
            dialogRef.current?.openDialog()
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
                type: 'alert-message',
                onAfterClose: () => {
                    setConfigDialog({})
                },
            })
        }
        loadingHook.loadingClose()
    }

    const handleSubmitUpdateMemo = (fieldNames: string[]) => {
        const isError = validateModeAccordionError(fieldNames, formRef.current)
        return new Promise(async (resolve, reject) => {
            if (isError) {
                formRef.current?.form.submit()
                reject('')
            } else {
                resolve('')
                const param: REQServiceType.UpdateMemoMessageType = {
                    submittedID: Number(projectData?.submittedID),
                    memoMessagePaperTH: formRef.current?.values.memoMessagePaper_TH.contentText,
                    memoMessagePaperEN: formRef.current?.values.memoMessagePaper_EN.contentText,
                    memoMessagePaperTHHTML: formRef.current?.values.memoMessagePaper_TH.contentHtml,
                    memoMessagePaperENHTML: formRef.current?.values.memoMessagePaper_EN.contentHtml,
                }
                updateMemoMessage(param)
            }
        })
    }

    const handleCancle = () => {
        const valueMessageTH: InitialRichTextEditorType = {
            contentHtml: editRef.current[`memoMessagePaper_TH`].contentHtml,
            contentText: editRef.current[`memoMessagePaper_TH`].contentText,
        }
        const valueMessageEN: InitialRichTextEditorType = {
            contentHtml: editRef.current[`memoMessagePaper_EN`].contentHtml,
            contentText: editRef.current[`memoMessagePaper_EN`].contentText,
        }
        setInitialMemoMessagePaper((prev) => ({
            TH: {
                ...prev?.TH,
                ...valueMessageTH,
            },
            EN: {
                ...prev?.EN,
                ...valueMessageEN,
            },
        }))
    }

    const onClickEdit = () => {
        editRef.current = formRef.current?.form.getState().values
    }
    return {
        formRef,
        required,
        isViewMode,
        configDialog,
        initialValues,
        approveStatus,
        isCheckedOther,
        isShowUpdateDate,
        terminateCauseList,
        initialMemorandumFile,
        initialMemoMessagePaper,
        initialSuggestionNotice,
        onRefDialog,
        onSubmitForm: handleSubmitForm,
        onDirtyChange: handleDirtyChange,
        onChangeStatus: handleChangeStatus,
        onClickCheckbox: handleClickCheckbox,
        onClickOpenFile: handleClickOpenFile,
        onChangProjectType: handleChangProjectType,
        onClickBackToSearch: handleClickBackToSearch,
        handleSubmitUpdateMemo,
        handleCancle,
        onClickEdit,
    }
}

export default useMemomessageTerminate
